module.exports = __webpack_public_path__ + "static/media/ergo.a37bf114.svg";